// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--2q8kb","content":"Footer-module--content--1-F_h","images":"Footer-module--images--2n4jh","copyright":"Footer-module--copyright--2-smO"};